import script from "./SRTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SRTable.vue?vue&type=script&setup=true&lang=js"

import "./SRTable.vue?vue&type=style&index=0&id=15e1392c&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15e1392c"]])

export default __exports__